import { Alert, Button } from "reactstrap";
import { useTranslation } from "react-i18next";
import { CyPushNeededInfo } from "../CyPushNeededInfo";

export function PushNeededInfo() {
  const { t } = useTranslation();
  return (
    <Alert color="warning" fade={false}>
      {t("playlist.edit.pushNeeded")}{" "}
      <Button
        color="link"
        data-cy={CyPushNeededInfo.ButtonSyncNow}
        style={{
          borderStyle: "none",
          padding: "0",
          verticalAlign: "baseline",
        }}
        onClick={() => window.location.reload()}
      >
        {t("playlist.edit.syncNow")}
      </Button>
    </Alert>
  );
}
